<template>
    <div id="email-template-builder-modal">
        <UIModal
            v-if="isModalOpen"
            modal-class="flex justify-center items-center h-full !p-0"
            modal-content-class="bg-white relative flex flex-col max-h-full mx-4 bg-white rounded modal-container transition-transform duration-100 !h-[97%] !w-[93%] !my-0"
            :show-modal="isModalOpen"
            @hide="modalClosed"
            :close-on-backdrop="false"
            hide-footer
            hide-close-button
            hide-title
            :size="'full'"
            body-class="!p-0 w-full"
            @update:show-modal="isModalOpen = $event"
            to="#email-template-builder-modal"
            :background-drop-color="'bg-[#00000080]'"
        >
           <Builder v-if="isModalOpen && templateId" :location="{ company_id: companyId, id:currentLocationId }" :user="user" :routePath="`/location/${currentLocationId}/emails/create/${templateId}/builder?isModalDialog=true&cloneTemplate=${createNewTemplate}`" @model:close="modalClosed" :customValues="customValues"  :source="source" :sourceId="sourceId" :subSourceId="subSourceId" :skipCheck="skipCheck"/>
        </UIModal>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import config from '../../../config'
import { EventBus } from '@/models/event-bus'
import Builder from './Builder.vue'
import UIModal from '@/compatibility/modal/UIModal.vue'

interface EditEmailTemplateData {
    templateId: string | undefined
    locationId?: string
    customValues?: any
    createNewTemplate?: boolean
    source?: string | undefined | null
    sourceId?: string | undefined | null
    subSourceId?: string | undefined | null
    skipCheck?: boolean
}

export default defineComponent({

    created() {
        EventBus.$on('edit-email-template', ({templateId, locationId, customValues, createNewTemplate, source, sourceId, subSourceId, skipCheck}:EditEmailTemplateData) => {
            if (templateId) {
                this.isModalOpen = true
                this.templateId = templateId || ''
                this.locationId = locationId || ''
                this.customValues = customValues || []
                this.createNewTemplate = createNewTemplate || false
                this.sourceId = sourceId || ''
                this.subSourceId = subSourceId || ''
                this.source = source || ''
                this.skipCheck = skipCheck
            }
        })
    },
    mounted() {
    },
    components: {
        Builder,
        UIModal
    },
    data() {
        return {
            locationId: '',
            calendarAppUrl: config.calendarAppUrl,
            isModalOpen: false,
            hasLoadedCalendarApp: false,
            templateId:'',
            customValues: [],
            createNewTemplate: false,
            sourceId: '',
            subSourceId: '',
            source: '',
            skipCheck: false
        }
    },
    computed: {
        user() {
            return this.$store.state.user.user
        },
        currentLocationId() {
            return this.locationId || this.$route.params.location_id
        },
        companyId() {
            return this.$store.state.user.user.company_id
        }
    },
    methods: {
        modalClosed(data: {
            clonedTemplateId: string,
            isSubjectChanged: boolean,
            isNewTemplate: boolean
        }) {
            this.isModalOpen = false
            EventBus.$emit('edit-email-template-closed', data)
        },
    },
    beforeUnmount() {
        EventBus.$off('edit-email-template')
    }
})
</script>

<style>
.modal-conatiner {
    height: 97%;
    width: 93%;
}
#email-template-builder-modal .n-drawer-content-wrapper {
    height: calc(100% - 30px);
}
</style>
